<template>
  <form-wrapper>
    <form-group>
      <validation-provider v-slot="{errors}" rules="required">
        <icu-select
          :errors="[...errors, ...getFieldErrors('citizenship')]"
          :value="stepFormData.citizenship"
          :options="getCountries()"
          :label="$t('application-form.step-0.citizenship')"
          :placeholder="isResident? 'Україна' : 'Ukraine'"
          required
          :searchable="true"
          @input="emitInput('citizenship', $event)"
        />
      </validation-provider>
      <validation-provider v-slot="{errors}" rules="required">
        <text-input
          v-if="isResident"
          :errors="[...errors, ...getFieldErrors('residency')]"
          :value="getCountryName(stepFormData.residency)"
          :label="$t('application-form.step-0.residency')"
          placeholder="Україна"
          required
          :disabled="true"
        />
        <icu-select
          v-else
          :errors="[...errors, ...getFieldErrors('residency')]"
          :value="stepFormData.residency"
          :options="getCountries(true,false)"
          :label="$t('application-form.step-0.residency')"
          :placeholder="isResident? 'Україна' : 'Ukraine'"
          required
          :searchable="true"
          @input="emitInput('residency', $event)"
        />
      </validation-provider>
    </form-group>


    <employment-step
      v-if="isResident && stepFormData.residency === 'UA'"
      :step-form-data="stepFormData.employment"
      :backend-errors="backendErrors.employment"
      @update-field="emitInput($event.formKey, $event.value)"
    ></employment-step>
  </form-wrapper>
</template>

<script>

import FormWrapper from '@/components/views/RegisterPage/FormWrapper.vue'
import FormGroup from '@/components/views/RegisterPage/FormGroup.vue'
import { ValidationProvider } from 'vee-validate'
import IcuSelect from '@/components/inputs/IcuSelect.vue'
import TextInput from '@/components/inputs/TextInput'
import EmploymentStep from '@/components/views/RegisterPage/EmploymentStep'

export default {
  name: 'CitizenshipStep',
  components: {EmploymentStep, TextInput, IcuSelect, FormGroup, FormWrapper, ValidationProvider },
  props: {
    stepFormData: {
      type: Object,
      required: true
    },
    backendErrors: {
      type: Object,
      default: () => {}
    },
    countries: {
      type: Array,
      default:()=> []
    },
    isResident: {
      type: Boolean,
      required: true
    }
  },
  dateNow: new Date(),
  mounted(){
    if(this.isResident){
      this.emitInput('residency', 'UA')
    }
  },
  methods: {
    getCountries(removeUA = false, addBlankVariant = true) {
      const countries = [...this.countries]
      if(addBlankVariant) {
        const noCitizenshipItem = {
          id: 'no_citizenship',
          name: this.isResident ? 'Особа без громадянства' : 'Statelessness'
        }
        countries.push(noCitizenshipItem)
      }
      if(!this.isResident && removeUA){
        const indexUA = countries.findIndex(el => el.id === 'UA')

        if (indexUA > -1) {
          countries.splice(indexUA, 1)
        }
      }

      return countries
    },
    getCountryName(id) {
      if(id) {
        const countryObj = this.countries.find(el => el.id === id)
        return countryObj?.name || ''
      }
      return ''
    },
    emitInput(formKey, value) {
      this.$emit('update-field', {formKey, value})
    },
    getFieldErrors(fieldName) {
      return this.backendErrors[fieldName] ?? []
    },
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";
</style>
